export { default } from './CreatedEvent';
